



























import Vue from 'vue'
import RunTable from '@/components/spiders/results/run-table.vue'
import { RunRepository } from '@/core/api/results'

export default Vue.extend({
  components: {
    RunTable,
  },
  data: () => ({
    page: 1,
    pages: 1,
    items: [],
    loading: false,
  }),
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      new RunRepository()
        .$getPage(this.page)
        .then(r => {
          this.items = r.results
          this.pages = r.pages
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onRowClick(item) {
      this.$router.push({ name: 'RunDetail', params: { id: item.id } })
    },
    onPageChange() {
      this.fetch()
    },
  },
})
